import { Checkbox, Text } from '@fluentui/react-components';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { IPermissionsDialogForm } from '../../../PermissionsDialogForm';
import { PermissionsHStack } from '../../PermissionsHStack';

export function PermissionsCreateGroup() {
  const { t } = useTranslation();
  const { control } = useFormContext<IPermissionsDialogForm>();
  return (
    <div>
      <Text style={{ marginBottom: '2px' }}>{t('permissions.modifyAction.createGroup.label')}</Text>

      <PermissionsHStack>
        <Controller
          control={control}
          name="canCreateItems"
          render={({ field: { value, onChange } }) => (
            <Checkbox
              label={t('permissions.modifyAction.createGroup.options.createItems')}
              checked={value}
              onChange={(_, d) => {
                onChange(d.checked);
              }}
            />
          )}
        />
        <Controller
          control={control}
          name="canCreateSubfolders"
          render={({ field: { value, onChange } }) => (
            <Checkbox
              label={t('permissions.modifyAction.createGroup.options.createSubfolders')}
              checked={value}
              onChange={(_, d) => {
                onChange(d.checked);
              }}
            />
          )}
        />
      </PermissionsHStack>
    </div>
  );
}
